import React, { useEffect, useState } from "react";
import {
  CompleteDentureForm,
  CompleteDentureProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputOld";
import SelectInput from "../formComp/SelectInputOld";
import ToothSelector from "../formComp/ToothSelectorOld";

const CompletDenture: React.FC<CompleteDentureProps> = ({ onChange }) => {
  const [form, setForm] = useState<CompleteDentureForm>({
    teethReplaced: [],
    occlusionType: "",
    desiredOutput: "",
    patientGender: "",
    patientAgeGroup: "",
    finishedProduct: "",
    modelNeeded: "",
    shade: "",
    additionalNotes: "",
  });

  const handleToothClick = (type: "teethReplaced", tooth: number) => {
    const toothStr = tooth.toString();

    setForm((prev) => {
      const updated = prev[type].includes(toothStr)
        ? prev[type].filter((t) => t !== toothStr)
        : [...prev[type], toothStr];
      return { ...prev, [type]: updated };
    });
  };

  const handleChange = (field: keyof CompleteDentureForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className="font-bold mb-4 border-b-2 border-[#2fa9bf]">
        LDP COMPLETE DENTURE
      </h2>

      <div className="w-[100%] md:w-[90%]">
        {/* Tooth Selection */}
        <div className="mb-2 flex">
          <label className="block mb-1 w-[35%]">
            Teeth to be replaced<span className="text-red-500">*</span>
          </label>
          <div className="w-[65%]">
            <ToothSelector
              toothNumbers={form.teethReplaced}
              onToothClick={(tooth) => handleToothClick("teethReplaced", tooth)}
            />
          </div>
        </div>

        {/* Occlusion type */}
        <SelectInput
          label="Occlusion type"
          name="occlusionType"
          value={form.occlusionType}
          onChange={(e) => handleChange("occlusionType", e.target.value)}
          options={[
            { value: "Anatomic", label: "Anatomic" },
            { value: "Semi-Anatomic", label: "Semi-Anatomic" },
            { value: "Non-Anatomic", label: "Non-Anatomic" },
          ]}
        />

        {/* Desired output */}
        <SelectInput
          label="Desired output"
          name="desiredOutput"
          value={form.desiredOutput}
          onChange={(e) => handleChange("desiredOutput", e.target.value)}
          options={[
            { value: "Monoblock", label: "Monoblock" },
            {
              value: "Separate gingiva and teeth",
              label: "Separate gingiva and teeth",
            },
            {
              value: "both",
              label: "Both",
            },
          ]}
        />

        {/* Patient gender */}
        <SelectInput
          optional
          label="Patient gender"
          name="patientGender"
          value={form.patientGender}
          onChange={(e) => handleChange("patientGender", e.target.value)}
          options={[
            { value: "Male", label: "Male" },
            { value: "Female", label: "Female" },
          ]}
        />

        {/* Patient age group */}
        <SelectInput
          optional
          label="Patient age group"
          name="patientAgeGroup"
          value={form.patientAgeGroup}
          onChange={(e) => handleChange("patientAgeGroup", e.target.value)}
          options={[
            { value: "Young", label: "Young" },
            { value: "Middle age", label: "Middle age" },
            { value: "Old", label: "Old" },
          ]}
        />

        {/* Finished product */}
        <SelectInput
          optional
          label="Finished product"
          name="finishedProduct"
          value={form.finishedProduct}
          onChange={(e) => handleChange("finishedProduct", e.target.value)}
          options={[
            { value: "Print only", label: "Print only" },
            { value: "Print, fuse & cure", label: "Print, fuse & cure" },
            {
              value: "Print, fuse, cure & finish",
              label: "Print, fuse, cure & finish",
            },
          ]}
        />

        {/* Is 3D model needed? */}
        <SelectInput
          optional
          label="Is 3D model needed?"
          name="modelNeeded"
          value={form.modelNeeded}
          onChange={(e) => handleChange("modelNeeded", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        {/* Shade */}
        <TextInput
          optional
          label="Shade"
          name="shade"
          value={form.shade}
          onChange={(e) => handleChange("shade", e.target.value)}
        />
        {/* Additional notes */}
        <TextInput
          optional
          label="Additional notes"
          name="additionalNotes"
          value={form.additionalNotes}
          onChange={(e) => handleChange("additionalNotes", e.target.value)}
        />
      </div>
    </div>
  );
};

export default CompletDenture;
